import { Typography } from '@mui/material';
import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { VrsCallCommentsBugReportForm } from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Textarea } from 'features/ui/elements';

interface VrsCallCommentsBugReportTextareaControlProps {
  control: Control<VrsCallCommentsBugReportForm>;
  isRequired: boolean;
}
export const VrsCallCommentsBugReportTextareaControl: FC<
  VrsCallCommentsBugReportTextareaControlProps
> = ({ control, isRequired }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'bugReport',
  });
  const maxLength = 1500;

  return (
    <>
      <Typography variant='h2' color={theme.palette.common.white} mt={12}>
        {t('otherReasonTitle')}
      </Typography>
      <Typography variant='subtitle2' color={theme.palette.grey[300]} mt={12}>
        {t('additionalText')}
      </Typography>
      <Controller
        control={control}
        name='commentText'
        rules={{ maxLength, required: isRequired }}
        render={({ field: { ref, ...args } }) => (
          <Description
            title='comment-text'
            {...args}
            slotProps={{ htmlInput: { maxLength } }}
          />
        )}
      />
    </>
  );
};

const Description = styled(Textarea)`
  margin-top: ${theme.spacing(8)};
`;
